var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getCognitoIdToken } from 'services/auth/AuthService';
var ApiService = /** @class */ (function () {
    function ApiService() {
        this.defaultRetryConfig = {
            maxRetries: 2,
            baseDelay: 1000,
            multiplier: 2,
        };
        if (!process.env.REACT_APP_API_URL) {
            throw Error('missing REACT_APP_API_URL env variable');
        }
        this.url = process.env.REACT_APP_API_URL;
    }
    ApiService.handleForbidden = function (status) {
        if (status === 403) {
            window.location.href = '/403';
        }
    };
    ApiService.prototype.getWithRetry = function (suffix, signal, retryConfig) {
        if (retryConfig === void 0) { retryConfig = this.defaultRetryConfig; }
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.withRetry(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, this.get(suffix, signal)];
                    }); }); }, signal, retryConfig)];
            });
        });
    };
    ApiService.prototype.get = function (suffix, signal) {
        return __awaiter(this, void 0, Promise, function () {
            var myHeaders, response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiService.buildHeaders()];
                    case 1:
                        myHeaders = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.url, "/").concat(suffix), {
                                method: 'GET',
                                headers: myHeaders,
                                signal: signal,
                            })];
                    case 3:
                        response = _b.sent();
                        ApiService.handleForbidden(response.status);
                        _a = {};
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = _b.sent(),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        error_1 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.log('error', error_1);
                        throw error_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.post = function (suffix, body, signal) {
        return __awaiter(this, void 0, Promise, function () {
            var myHeaders, response, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiService.buildHeaders()];
                    case 1:
                        myHeaders = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.url, "/").concat(suffix), {
                                method: 'POST',
                                headers: myHeaders,
                                body: JSON.stringify(body),
                                redirect: 'follow',
                                signal: signal,
                            })];
                    case 3:
                        response = _b.sent();
                        ApiService.handleForbidden(response.status);
                        _a = {};
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = _b.sent(),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        error_2 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.log('error', error_2);
                        throw error_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.put = function (suffix, body, signal) {
        return __awaiter(this, void 0, Promise, function () {
            var myHeaders, response, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiService.buildHeaders()];
                    case 1:
                        myHeaders = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.url, "/").concat(suffix), {
                                method: 'PUT',
                                headers: myHeaders,
                                body: JSON.stringify(body),
                                redirect: 'follow',
                                signal: signal,
                            })];
                    case 3:
                        response = _b.sent();
                        ApiService.handleForbidden(response.status);
                        _a = {};
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = _b.sent(),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        error_3 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.log('error', error_3);
                        throw error_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.delete = function (suffix, body, signal) {
        return __awaiter(this, void 0, Promise, function () {
            var myHeaders, response, error_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiService.buildHeaders()];
                    case 1:
                        myHeaders = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch("".concat(this.url, "/").concat(suffix), {
                                method: 'DELETE',
                                headers: myHeaders,
                                body: body ? JSON.stringify(body) : undefined,
                                redirect: 'follow',
                                signal: signal,
                            })];
                    case 3:
                        response = _b.sent();
                        ApiService.handleForbidden(response.status);
                        _a = {};
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = _b.sent(),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        error_4 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.log('error', error_4);
                        throw error_4;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.buildHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var myHeaders, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        myHeaders = new Headers();
                        _b = (_a = myHeaders).append;
                        _c = ['Authorization'];
                        _d = "Bearer ".concat;
                        return [4 /*yield*/, getCognitoIdToken()];
                    case 1:
                        _b.apply(_a, _c.concat([_d.apply("Bearer ", [_e.sent()])]));
                        myHeaders.append('Content-Type', 'application/json');
                        return [2 /*return*/, myHeaders];
                }
            });
        });
    };
    /**
     * Determines if an error should trigger a retry attempt.
     * Retries on network errors and 5xx server errors, but not on 4xx client errors or AbortError.
     */
    ApiService.isRetryableError = function (error, status) {
        // Check for AbortError (user cancelled request)
        if (error.name === 'AbortError') {
            return false;
        }
        return this.isRetryableStatus(status);
    };
    ApiService.isRetryableStatus = function (status) {
        if (status !== undefined) {
            // Retry on 5xx errors and 429 (throttling), but not other client side errors
            return (status >= 500 && status < 600) || status === 429;
        }
        // Network errors (no status) are retryable
        return true;
    };
    /**
     * Calculates and executes exponential backoff delay.
     */
    ApiService.delay = function (attemptNumber, retryConfig) {
        return __awaiter(this, void 0, Promise, function () {
            var delayMs;
            return __generator(this, function (_a) {
                delayMs = retryConfig.baseDelay * (Math.pow(retryConfig.multiplier, attemptNumber));
                return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, delayMs); })]; // eslint-disable-line no-promise-executor-return
            });
        });
    };
    /**
     * Wraps an async operation with retry logic and exponential backoff.
     */
    ApiService.prototype.withRetry = function (operation, signal, retryConfig) {
        if (retryConfig === void 0) { retryConfig = this.defaultRetryConfig; }
        return __awaiter(this, void 0, Promise, function () {
            var lastError, lastStatus, attempt, isLastAttempt, response, shouldRetry, error_5, shouldRetry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempt = 0;
                        _a.label = 1;
                    case 1:
                        if (!(attempt <= retryConfig.maxRetries)) return [3 /*break*/, 8];
                        isLastAttempt = attempt === retryConfig.maxRetries;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Check if request was aborted before attempting
                        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                            throw new DOMException('Aborted', 'AbortError');
                        }
                        return [4 /*yield*/, operation()];
                    case 3:
                        response = _a.sent();
                        shouldRetry = ApiService.isRetryableStatus(response.status);
                        if (isLastAttempt || !shouldRetry) {
                            return [2 /*return*/, response];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_5 = _a.sent();
                        lastError = error_5;
                        // Extract status if available from the error
                        if (error_5 && typeof error_5 === 'object' && 'status' in error_5) {
                            lastStatus = error_5.status;
                        }
                        shouldRetry = ApiService.isRetryableError(error_5, lastStatus);
                        if (isLastAttempt || !shouldRetry) {
                            // eslint-disable-next-line no-console
                            console.error('error', error_5);
                            throw error_5;
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        // eslint-disable-next-line no-console
                        console.log("Retry attempt ".concat(attempt + 1, "/").concat(retryConfig.maxRetries));
                        // eslint-disable-next-line no-await-in-loop
                        return [4 /*yield*/, ApiService.delay(attempt, retryConfig)];
                    case 6:
                        // eslint-disable-next-line no-await-in-loop
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        attempt += 1;
                        return [3 /*break*/, 1];
                    case 8: throw lastError;
                }
            });
        });
    };
    return ApiService;
}());
export var apiService = new ApiService();
